import 'css-chunksrc/client/scenes/optimizedGantt/workloads/group/styles.scss';export default {
  "name": "_name_1uujl_1",
  "header": "_header_1uujl_8",
  "icon": "_icon_1uujl_14",
  "iconBox": "_iconBox_1uujl_22",
  "toggleArrow": "_toggleArrow_1uujl_29",
  "openedIcon": "_openedIcon_1uujl_39",
  "resource": "_resource_1uujl_43"
};